import React from 'react';
import { useNavigate } from 'react-router-dom';

const PayUs = () => {
  const navigate = useNavigate();
  const razorpayLink = 'https://razorpay.me/@cloudaiprivatelimited';

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #89f7fe 0%, #66a6ff 100%)',
      fontFamily: 'Inter, sans-serif',
    }}>
      <div style={{
        background: 'rgba(255,255,255,0.92)',
        backdropFilter: 'blur(14px)',
        borderRadius: '20px',
        padding: '50px 48px',
        maxWidth: '580px',
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
        border: '1px solid rgba(255,255,255,0.6)',
      }}>
        <div style={{ fontSize: '3.5rem', marginBottom: '16px', color: '#1565c0' }}>💳</div>
        <h2 style={{
          color: '#1565c0',
          fontSize: '1.8rem',
          fontWeight: '700',
          marginBottom: '12px',
          marginTop: 0,
        }}>
          Make a Secure Payment
        </h2>
        <p style={{
          color: '#546e7a',
          fontSize: '1rem',
          fontWeight: '500',
          marginBottom: '30px',
        }}>
          Pay to <strong>TrustApp (CloudAI Private Limited)</strong>
        </p>
        <p style={{
          color: '#546e7a',
          fontSize: '0.95rem',
          lineHeight: '1.7',
          marginBottom: '40px',
        }}>
          To complete your payment, you will be redirected to Razorpay, our trusted and secure payment partner. Your transaction details are always kept safe.
        </p>
        <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            onClick={() => navigate('/utility-dashboard')}
            style={{
              minWidth: '160px',
              padding: '13px 20px',
              backgroundColor: 'transparent',
              color: '#546e7a',
              border: '1.5px solid #cfd8dc',
              borderRadius: '10px',
              fontSize: '0.95rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = '#2196f3';
              e.currentTarget.style.color = '#2196f3';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = '#cfd8dc';
              e.currentTarget.style.color = '#546e7a';
            }}
          >
            Go to Dashboard
          </button>
          <a
            href={razorpayLink}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              minWidth: '160px',
              padding: '14px 32px',
              background: 'linear-gradient(135deg, #43a047, #2e7d32)',
              color: 'white',
              border: 'none',
              borderRadius: '10px',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: 'pointer',
              textDecoration: 'none',
              transition: 'transform 0.15s, box-shadow 0.2s',
              boxShadow: '0 4px 14px rgba(76,175,80,0.35)',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 6px 20px rgba(76,175,80,0.45)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 14px rgba(76,175,80,0.35)';
            }}
          >
            Proceed to Pay
          </a>
        </div>
      </div>
    </div>
  );
};

export default PayUs;